import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, ProductDetailsCard, Typography } from 'mobily-ui-library/lib';
import { GlobalContext } from '../../../context/GlobalContext';

import ErrorModal from '../../ErrorModal/ErrorModal';

import { captureData, removeAndCancelCart, updateAndValidateSC } from '../../../api/api';
import { delete_cookie } from '../../../Utils/deleteCookies';
import captureStructure from '../../../captureStructure.json';

import Brand from '../../../assets/Brand.svg';
import Tick from '../../../assets/Tick.svg';

import './SubsidySuccess.scss';

const win: any = window;
const serverURL = win['base_portal_url'];
const errorPage = win['errorPageURL'];
const cartPage = win['cart_app_url'];

function SubsidySuccess() {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, productData, cartId, msisdn, otpValue, customerAccount, promotionType, promoTypeCode, promoTypeValue, promoPeriod, promoAmount, deviceFlow, appliedInstallment } = state;

    const { t } = useTranslation();

    const preOrder = productData.preOrder;
    const isOutOfStock = false;
    let colorCode;
    let capacity;
    if (productData?.category?.deviceSubType.valueEn === "Smart Watches") {
        colorCode = rtl ? productData?.caseColorCode.valueAr : productData?.caseColorCode.valueEn;
        capacity = rtl ? productData?.caseSize.valueAr : productData?.caseSize.valueEn;
    } else {
        colorCode = rtl ? productData?.colorCode.valueAr : productData?.colorCode.valueEn;
        capacity = rtl ? productData?.capacity.valueAr : productData?.capacity.valueEn;
    }

    const productDescription = `${colorCode}, ${capacity}`;
    const productPrice = `${productData?.priceWithoutVAT} ${t('SAR')}`;
    const productName = rtl ? productData?.category.name.valueAr : productData?.category.name.valueEn
    const productImage = serverURL + productData?.category.defaultURL;
    const installmentMonths = appliedInstallment?.PromotionCommitmentPeriod ? appliedInstallment?.PromotionCommitmentPeriod : "";
    const installmenAmount = appliedInstallment?.MonthlyCommitmentAmt ? appliedInstallment?.MonthlyCommitmentAmt : "";

    const [removeClick, setRemoveClick] = useState(false)

    const handleRemoveSubsidy = () => {
        setRemoveClick(true)
    }

    const handleGoToCart = () => {
        dispatch({ type: "LOADER", payload: { loading: true } });
        updateAndValidateSCAPI();
    }

    const updateAndValidateSCAPI = () => {
        updateAndValidateSC(cartId)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    captureDataApi(res?.data?.shoppingCart)
                    dispatch({ type: "LOADER", payload: { loading: false } });
                } else {
                    window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                }
            }).catch(err => {
                window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
            })
    }

    const captureDataApi = (scData: any) => {
        const sections: any = ({
            ...captureStructure,
            steps: captureStructure?.steps.map((step: any) => ({
                ...step,
                offerContainerId: scData.offerContainer[0].id,
                options: [
                    {
                        name: 'Login',
                        value: 'Mobily number',
                        fields: [
                            {
                                name: 'Mobily number',
                                value: msisdn
                            }
                        ]
                    }
                ],
                fields: step.fields.map((field: any) => {
                    let fieldValues = field;

                    if (field.name === 'Continue As Guest') {
                        fieldValues = ({
                            ...field,
                            value: 'No'
                        })
                    } else if (field.name === 'OTP') {
                        fieldValues = ({
                            ...field,
                            value: otpValue
                        })
                    } else if (field.name === 'CustomerRelatedAcccountInquiryResponse') {
                        fieldValues = ({
                            ...field,
                            value: JSON.stringify(customerAccount)
                        })
                    } else if (field.name === 'MobilyMSISDN') {
                        fieldValues = ({
                            ...field,
                            value: '' //pass encrpty BMNumber value when using ID Number in Login
                        })
                    } else if (field.name === 'promoTypeCode') {
                        fieldValues = ({
                            ...field,
                            value: promoTypeCode
                        })
                    } else if (field.name === 'promoTypeValue') {
                        fieldValues = ({
                            ...field,
                            value: promoTypeValue
                        })
                    } else if (field.name === 'promotionTermAndCondition') {
                        fieldValues = ({
                            ...field,
                            value: 'true'
                        })
                    } else if (field.name === 'deviceInstallment') {
                        fieldValues = ({
                            ...field,
                            value: deviceFlow === 'subsidy' ? 'false' : 'true'
                        })
                    }

                    return fieldValues
                })
            }))

        });

        captureData(scData, [sections])
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    window.location.href = `${serverURL}${cartPage}`
                } else {
                    window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                }
            }).catch(err => {
                window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
            })
    }

    const handleModalKeepSubsidy = () => {
        setRemoveClick(false);
    }

    const handleModalRemoveSubsidy = () => {
        dispatch({ type: "LOADER", payload: { loading: true } });

        removeAndCancelCart(cartId)
            .then((res: any) => {
                if (res.status === 201 && res.data) {
                    delete_cookie('device-count');
                    delete_cookie('device-scId');
                    delete_cookie('device-xCoId');
                    delete_cookie('device-poid');
                    delete_cookie('device-journeyName');
                    window.location.reload();
                    const wcmElement: any = document.getElementById("reactWCMControlBlockID");
                    if (wcmElement !== null) {
                        wcmElement.style.display = 'block';
                    }
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                }
            }).catch(err => {
                window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
            })
    }

    return (
        <>

            <div className='Devices__SubsidySuccess'>
                <ProductDetailsCard
                    rtl={rtl}
                    status={preOrder ? t('pre_order') : ""}
                    borderON={true}
                    beforeDiscount=""
                    devicesImage={productImage}
                    productDescription={productDescription}
                    productName={productName}
                    productPrice={isOutOfStock ? t('sold_out') : productPrice}
                    Trashicon={true}
                    promotionTextTitle={deviceFlow === 'subsidy' ? "" : `${t('installment')} ${installmenAmount} ${t('sar_month')}`}
                    promotionTextSubtitle={deviceFlow === 'subsidy' ? "" : `(${installmentMonths} ${t('Months_commitment')})`}
                />

                <div className='Devices__SubsidyType'>
                    <Typography rtl={rtl} className='DST__FinanceTitle'>{t('Mobily_Financing')}</Typography>

                    <div className='DST__Apply'>
                        <div className='DST__ApplyHead'>
                            <img src={Brand} alt='mobily-icon' />
                            <Typography rtl={rtl} className='DST__ApplyTitle'>{deviceFlow === 'subsidy' ? t('Device_subsidy') : t('device_installment')}</Typography>
                        </div>
                        <Typography rtl={rtl} className='DST__ApplyContent'>
                            {deviceFlow === 'subsidy' ? (
                                rtl ? `فترة التزام مقابل ${promoAmount} ريال لمدة ${promoPeriod} شهر، ساري فقط لباقات مفوتر محددة.تطبق الشروط والأحكام.` : `${promoAmount} SAR with a commitment period of ${promoPeriod} months. For selected Postpaid plans only. T&Cs apply`
                            ) : (
                                t('get_your_device_with_installment', { installment_amount_montly: installmenAmount, committed_months: installmentMonths })
                            )}
                        </Typography>

                        <Typography rtl={rtl} className='DST__ApplyLink'>
                            <img src={Tick} alt='arrow' />
                            <span className='DST__Success'>{deviceFlow === 'subsidy' ? `${promotionType} ${t('subsidy_applied')}` : t('installment_applied')}</span>
                            <span className='DST__ApplyRemove' onClick={handleRemoveSubsidy}>{t('Remove')}</span>
                        </Typography>
                    </div>
                </div>

                <div className='Devices__SubsidyStickyBox'>
                    <Button
                        rtl={rtl}
                        className='DSSTB__ApplyBtn'
                        onClick={handleGoToCart}
                    >
                        {t('Go_To_Cart')}
                    </Button>
                </div>
            </div>

            {removeClick && (
                <ErrorModal
                    id='duplicate-shopping-cartId'
                    rtl={rtl}
                    title={deviceFlow === 'subsidy' ? t('Remove_subsidy') : t('remove_installment')}
                    description={deviceFlow === 'subsidy' ? t('Are_you_remove_Subsidy') : t('are_you_sure_want_to_remove_installment')}
                    firstButtonText={deviceFlow === 'subsidy' ? t('Keep_subsidy') : t('keep_installment_button')}
                    secButtonText={deviceFlow === 'subsidy' ? t('Remove_subsidy_btn') : t('remove_installment_button')}
                    modalFirstButtonClick={handleModalKeepSubsidy}
                    modalSecondButtonClick={handleModalRemoveSubsidy}
                />
            )}
        </>
    )
}

export default SubsidySuccess